/**
 * Geräteschalter der Retoure (Stufe A: lokale Entwicklung und technische Abnahme).
 *
 * Vorgabe AUS. Eingeschaltet nur, wenn im Gerätespeicher `bilanx.retoureStufe1` genau `1` steht.
 * Es gibt keinen Schalter in der Oberfläche. Eingeschaltet erscheint im Verkauf unter „Mehr“ der
 * Eintrag „Retoure“ (F8); nutzbar ist er nur, wenn zusätzlich der Server die Retoure für diese
 * Kasse meldet (Journalabruf `GET /kassen/:id/retouren`, 404 = Server-Schalter aus; Vertrag 4.7).
 * Die produktive Aktivierung (Stufe B) ist nicht freigegeben.
 */
export const RETOURE_SCHALTER = 'bilanx.retoureStufe1';

/** Text des Reiters (offene Entscheidung RT-F2: in Stufe 1 ohne Umtausch nur „Retoure“). */
export const RETOURE_REITER_TEXT = 'Retoure';

export function retoureStufe1Aktiv(speicher: Pick<Storage, 'getItem'>): boolean {
  try {
    return speicher.getItem(RETOURE_SCHALTER) === '1';
  } catch {
    return false; // gesperrter Speicher (privater Modus) = aus
  }
}

/** Menüeintrag „Mehr“ → „Retoure“ – leer, solange der Schalter aus ist. */
export function retoureReiter(
  speicher: Pick<Storage, 'getItem'>,
): { id: 'retoure'; text: string }[] {
  return retoureStufe1Aktiv(speicher) ? [{ id: 'retoure', text: RETOURE_REITER_TEXT }] : [];
}

/** Sperrtext ohne Verbindung (Fachkonzept 12, Figma RT2-11). */
export const OFFLINE_TEXT = 'Retoure braucht Verbindung';

/** O10: Retoure nur auf T3 und Desktop (ab 1280 px); Tablet und Smartphone zeigen nur den Hinweis. */
export const HAUPTKASSE_TEXT = 'Retoure an der Hauptkasse';
export const RETOURE_MIN_BREITE = 1280;

export function retoureGeraetPasst(): boolean {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
    return true;
  }
  return window.matchMedia(`(min-width: ${String(RETOURE_MIN_BREITE)}px)`).matches;
}

/** Für Tests und den Menüeintrag: Grund, warum die Retoure gerade nicht startbar ist. */
export function retoureEinstiegSperre(z: {
  schalter: boolean;
  /** Gerät groß genug (T3/Desktop); fehlt = ja. */
  geraet?: boolean;
  online: boolean;
  training: boolean;
  laeuft: boolean;
  recht: boolean | undefined;
}): string | null {
  if (!z.schalter) {
    return 'Retoure ist nicht freigeschaltet.';
  }
  if (z.geraet === false) {
    return HAUPTKASSE_TEXT;
  }
  if (!z.online) {
    return OFFLINE_TEXT;
  }
  if (z.training) {
    return 'Im Training keine Retoure.';
  }
  if (z.laeuft) {
    return 'Erst den laufenden Vorgang abschließen.';
  }
  if (z.recht === false) {
    return 'Kein Recht „Retoure“.';
  }
  return null;
}
